import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {Popover} from 'antd';
import {WeaLocaleProvider, WeaIntro} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const {Step} = WeaIntro;
import {WeaPlugin, WeaLicense, WeaVersion, WeaSystemSetting} from  'weaPortalPublic';

@inject('portalIntroStore')
@inject('portalThemeStore')
@observer
class IntroStep4 extends React.Component {
    constructor(props) {
        super(props);
        this.onVisibleChange = this.onVisibleChange.bind(this);
        this.onMenuClick = this.onMenuClick.bind(this);
    }

    render() {
        const {portalThemeStore, portalIntroStore} = this.props;
        const {toolbarMoreMenu, toolbarMoreMenuVisible} = portalThemeStore;
        const _toolbarMoreMenu = toJS(toolbarMoreMenu);
        const {intro_step} = portalIntroStore;

        if (_toolbarMoreMenu.length == 0) {
            return null;
        }

        const contentComp = (
            <div className="e9header-toolbar-more-content">
                {
                    _toolbarMoreMenu.map((item, index) => {
                        const {id, name, icon, type} = item;

                        return (
                            <div key={index} className="e9header-toolbar-more-item" title={name} onClick={() => this.onMenuClick(item)}>
                                <i className={icon} style={type == 'cus' ? {margin: '-7px 0 0 2px', fontSize: '14px'} : {}}/>
                                <span>{name}</span>
                            </div>
                        );
                    })
                }
            </div>
        );

        return (
            <Popover
                trigger="click"
                placement="bottomLeft"
                content={<Step id={'portal-intro4'}>{contentComp}</Step>}
                overlayClassName="e9header-toolbar-more-overlay"
                visible={toolbarMoreMenuVisible}
                onVisibleChange={this.onVisibleChange}
                afterPopupVisibleChange={v => intro_step.intro4 && v && setTimeout(() => window.portal_intro.goToStep(4), 150)}
            >
                <div className="e9header-toolbar-more-icon" title={getLabel(17499, '更多')}>
                    <WeaPlugin ref="WeaPlugin"/>
                    <WeaLicense ref="WeaLicense"/>
                    <WeaVersion ref="WeaVersion"/>
                    <WeaSystemSetting ref="WeaSystemSetting"/>
                    <i className="wevicon-toolbar-more"/>
                </div>
            </Popover>
        );
    }

    onVisibleChange(visible) {
        const {portalThemeStore, portalIntroStore} = this.props;
        const {intro_step} = portalIntroStore;
        !intro_step.intro5 && portalThemeStore.onToolbarMoreMenuVisibleChange(visible);

        const themeLayoutMask = document.getElementById('themeLayoutMask');
        if (visible) {
            themeLayoutMask.style.display = 'block';
        } else {
            themeLayoutMask.style.display = 'none';
        }
    }

    onMenuClick(item) {
        this.onVisibleChange(false);

        let {id, url, mobxrouteurl, linkmode} = item;

        if (linkmode == '1') {
            if (id == '3' || id == '5' || id == '6' || id == '8') {
                const ref = {'3': 'WeaPlugin', '5': 'WeaLicense', '6': 'WeaVersion', '8': 'WeaSystemSetting'}[id];
                this.refs[ref].onShow();
            } else {
                let redirectUrl = url;
                let width = screen.availWidth - 10;
                let height = screen.availHeight - 60;
                let szFeatures = "top=0,";
                szFeatures += "left=0,";
                szFeatures += "width=" + width + ",";
                szFeatures += "height=" + height + ",";
                szFeatures += "directories=no,";
                szFeatures += "status=yes,";
                szFeatures += "menubar=no,";
                szFeatures += "scrollbars=yes,";
                szFeatures += "resizable=yes";
                window.open(redirectUrl, "", szFeatures);
            }
        } else {
            const {portalThemeStore} = this.props;
            portalThemeStore.onLoadMain({url, mobxrouteurl, target: linkmode == '0' ? '_blank' : 'mainFrame'});
        }
    }
}

export default IntroStep4;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/portalintro/IntroStep4.js